function isNullOrWhiteSpace(str) {
    return !str || str.trim().length === 0;
}

const StringUtils = {
    isNullOrWhiteSpace
}

export default StringUtils